import TimePickerWithGesture from './TimePicker.component';

export default TimePickerWithGesture;
